import { Box } from '@mui/material';
import React from 'react';

import { ClickAwayAndKeydownListener } from '../../Components/ClickAwayAndKeydownListener';
import { DATA_OG, DATA_TEST } from '../../enums';
import { IProductDetails, PRODUCT_KEY } from '../../types';

import { ContextSwitcherMenuListContainer } from '../ContextSwitcherMenuListContainer';

import { AppSwitcherListItems } from './AppSwitcherListItems';

interface IMobileAppSwitcherProps {
  entitledApplications: IProductDetails[];
  activeProductKey: PRODUCT_KEY;
  firstAppSwitcherItemRef: React.MutableRefObject<HTMLLIElement>;
  handleClose(): void;
}

export const MobileAppSwitcher: React.FC<IMobileAppSwitcherProps> = ({
  handleClose,
  entitledApplications,
  activeProductKey,
  firstAppSwitcherItemRef
}) => {
  return (
    <ClickAwayAndKeydownListener handleTrigger={handleClose} triggerKeys={['Escape']}>
      <Box
        sx={{ display: 'flex', flexDirection: 'column' }}
        data-og={DATA_OG.context_switcher_container}
        data-test={DATA_TEST.context_switcher_container}
      >
        <ContextSwitcherMenuListContainer
          dataTest={DATA_TEST.app_switcher_container}
          styleOverrides={{ border: 'none', boxShadow: 'none', borderRadius: 0 }}
        >
          <AppSwitcherListItems
            activeProductKey={activeProductKey}
            mobile={true}
            entitledApplications={entitledApplications}
            firstContextSwitcherItemRef={firstAppSwitcherItemRef}
            handleClose={handleClose}
          />
        </ContextSwitcherMenuListContainer>
      </Box>
    </ClickAwayAndKeydownListener>
  );
};
